export default {
  async goToAcademy(context) {
    const academyUrl = context.getters.academyUrl;
    context.commit('goToAcademy', {
      academyUrl: academyUrl,
    });
  },
  async goToCompany(context) {
    const companyUrl = context.getters.companyUrl;
    context.commit('goToCompany', {
      companyUrl: companyUrl,
    });
  },
  async goToFacebook(context) {
    const facebookUrl = context.getters.facebookUrl;
    context.commit('goToFacebook', {
      facebookUrl: facebookUrl,
    });
  },
  async goToInstagram(context) {
    const instagramUrl = context.getters.instagramUrl;
    context.commit('goToInstagram', {
      instagramUrl: instagramUrl,
    });
  },
  async goToLinkedin(context) {
    const linkedinUrl = context.getters.linkedinUrl;
    context.commit('goToLinkedin', {
      linkedinUrl: linkedinUrl,
    });
  },
  async goTotwitter(context) {
    const twitterUrl = context.getters.twitterUrl;
    context.commit('goToTwitter', {
      twitterUrl: twitterUrl,
    });
  },

  async showDirections(context){
   
    const mapUrl = context.getters.mapUrl;
    context.commit('goToMap', {
      mapUrl: mapUrl,
    });
  },


  cookiesAccepted(context) {
    context.commit('cookiesAccepted', {
      cookiesAccepted: false,
    });
  },

  viewSingleReport(context, payload) {
    context.commit('viewSingleReport', {
      viewsinglereport: payload.viewsinglereport,
    });
  },

  setSelectedActiveStudy(context,payload){
    context.commit('activeSelectedStudy',{
      activeSelectedStudy:payload.activeStudySelection
    })
  }
};
